import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { FormDashboard } from './FormDashboard';
import '../layout/sass/_responsiveTable.scss';
import '../layout/sass/_dashboard.scss';

export const DashBoard = () => {
    const toast = useRef(null);

    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <h1>Pedras</h1>

            <FormDashboard />
        </>
    );
}
